import moment from "moment";
class employees {
  constructor(operId, empId, from, to, nameOper, employee, file) {
    this.operId = operId;
    this.empId = empId;
    this.from = moment(from).utc().format("DD-MM-YYYY");
    this.to = to == null ? " " : moment(to).utc().format("DD-MM-YYYY");
    this.nameOper = nameOper;
    this.employee = employee;
    this.file = file;
  }
  static fromJson({
    operId,
    empId,
    fecDesde,
    fecHasta,
    nomOper,
    empleado,
    legajo,
  }) {
    return new employees(
      operId,
      empId,
      fecDesde,
      fecHasta,
      nomOper,
      empleado,
      legajo
    );
  }
}
export default employees;
